import { atom } from 'recoil'
import { UserGroupTypes } from 'services'

export const userGroupsList = atom<UserGroupTypes[]>({
  key: 'groupsList',
  default: []
})
